import React from 'react';
import { motion } from 'framer-motion';
import { FileText, ShoppingCart, Calendar, Activity, Heart, Shield } from 'lucide-react';
export function IncludesSection() {
  const items = [{
    icon: Calendar,
    title: 'Plan completo de 14 días',
    desc: 'Día por día, sin tener que pensar qué hacer.'
  }, {
    icon: FileText,
    title: 'Plantillas de comidas simples',
    desc: 'Opciones baratas y fáciles de preparar.'
  }, {
    icon: ShoppingCart,
    title: 'Lista de compras económica',
    desc: 'Pensada para supermercados en USA.'
  }, {
    icon: Activity,
    title: 'Rutina en silla',
    desc: 'Ejercicios seguros, suaves y efectivos.'
  }, {
    icon: Shield,
    title: "Protocolo 'Día Difícil'",
    desc: 'Estrategias para no abandonar si tienes un mal día.'
  }, {
    icon: Heart,
    title: 'Plan de mantención',
    desc: 'Cómo seguir después de los 14 días (3 días/semana).'
  }];
  return <section className="py-24 bg-white" data-id="element-163">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-165">
          <h2 className="text-4xl font-bold text-[#2D3748] mb-6" data-id="element-166">
            ¿Qué incluye exactamente?
          </h2>
          <p className="text-xl text-gray-600" data-id="element-167">
            Todo lo que necesitas para empezar mañana mismo, explicado paso a
            paso.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-168">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center text-center p-6 rounded-xl bg-[#FAF7F2] border border-gray-100" data-id="element-169">
              <div className="w-14 h-14 rounded-full bg-[#5B9BD5]/10 text-[#5B9BD5] flex items-center justify-center mb-4" data-id="element-170">
                <item.icon className="w-7 h-7" data-id="element-171" />
              </div>
              <h3 className="text-xl font-bold text-[#2D3748] mb-2" data-id="element-172">
                {item.title}
              </h3>
              <p className="text-lg text-gray-600" data-id="element-173">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}